import { render, staticRenderFns } from "./codec.vue?vue&type=template&id=3e2bf31c&scoped=true"
import script from "./codec.vue?vue&type=script&lang=js"
export * from "./codec.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2bf31c",
  null
  
)

export default component.exports